import Pager from 'admin/components/shared/Pager';
import { formatDate, formatUUID } from 'admin/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { createBadge } from '../../atoms/Badge';
import Table from '../../atoms/Table';

const TooltipTableCell = styled(Table.Cell)`
  &:hover {
    ${({ tooltip }) => tooltip && 'cursor: pointer; background-color: #eeeeee;'}
  }
`;

const Badge = createBadge({
  'not-started': {
    label: '開始前',
    bgColor: '#2684FF',
  },
  valid: {
    label: '有効',
    bgColor: '#1EAC21',
  },
  paused: {
    label: '停止中',
    bgColor: '#BF9105',
  },
  'usage-limit-reached': {
    label: '上限到達',
    bgColor: '#525252',
  },
  expired: {
    label: '期限切れ',
    bgColor: '#525252',
  },
});

const ListTable = ({ checks, pagination, onChangePage }) => {
  const columns = [
    { label: '状態', size: 1, align: 'left' },
    { label: 'ID', size: 1, align: 'left' },
    {
      label: '開始日時',
      size: 1,
      align: 'left',
    },
    {
      label: '終了日時',
      size: 1,
      align: 'left',
    },
    { label: '用途', size: 2, align: 'left' },
    { label: 'マネー', size: 1, align: 'right' },
    { label: 'ポイント', size: 1, align: 'right' },
    {
      label: '利用人数',
      size: 1,
      align: 'right',
      tooltipKey: 'numberOfUses',
      tooltipText: 'QRコードを受け取り可能なお客様の数',
    },
    {
      label: 'チャージ元店舗',
      size: 2,
      align: 'left',
    },
  ];

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {columns.map((c) => (
            <TooltipTableCell
              key={c.label}
              tooltip={!!c.tooltipKey && !!c.tooltipText}
              size={c.size}
              align={c.align}
              data-tip
              data-for={c.tooltipKey}
            >
              {c.label}
              {!!c.tooltipKey && !!c.tooltipText && (
                <ReactTooltip id={c.tooltipKey} type="dark" place="top" effect="solid">
                  <span>{c.tooltipText}</span>
                </ReactTooltip>
              )}
            </TooltipTableCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {checks?.map((check) => (
          <Table.Row
            key={check.id}
            style={{
              background:
                check.status === 'usage-limit-reached' || check.status === 'expired'
                  ? '#ddd'
                  : 'unset',
            }}
          >
            <Table.Cell wordBreak="keep-all">
              <Badge status={check.status} />
            </Table.Cell>
            <Table.Cell wordBreak="keep-all">
              <Link to={`/promotion/checks/${check.id}`}>{formatUUID(check.id)}</Link>
            </Table.Cell>
            <Table.Cell>
              <span>{formatDate(check.starts_at, 'YYYY/MM/DD HH:mm')}</span>
            </Table.Cell>
            <Table.Cell>
              <span>{formatDate(check.expires_at, 'YYYY/MM/DD HH:mm')}</span>
            </Table.Cell>
            <Table.Cell wordBreak="break-word">
              <span>{check.note}</span>
            </Table.Cell>
            <Table.Cell align="right">
              <span>{check.money_amount.toLocaleString()}</span>
            </Table.Cell>
            <Table.Cell align="right">
              <span>{check.point_amount.toLocaleString()}</span>
            </Table.Cell>
            <Table.Cell align="right">
              <span>
                {(() => {
                  // For one-time checks: show 0/1 or 1/1 based on last_used_at status
                  if (check.is_onetime) {
                    return `${check.last_used_at ? 1 : 0}/1`;
                  }

                  // For regular checks: show count/limit if limit exists
                  return check.usage_limit ? `${check.usage_count}/${check.usage_limit}` : '';
                })()}
              </span>
            </Table.Cell>
            <Table.Cell wordBreak="break-word">
              <span>{check.user.name}</span>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan="10" align="center" styles={{ paddingTop: '16px' }}>
            <Pager pagination={pagination} onChangePage={onChangePage} />
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

ListTable.propTypes = {
  checks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      created_at: PropTypes.string,
      user: PropTypes.object,
      money_amount: PropTypes.number,
      point_amount: PropTypes.number,
      usage_count: PropTypes.number,
      usage_limit: PropTypes.number,
      description: PropTypes.string,
      is_disabled: PropTypes.bool,
    })
  ).isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(styled(ListTable)``);
